import { useQuery } from "@tanstack/react-query";
import { getPromoCodes } from "@/services/pricingService";
import { Sparkles } from "lucide-react";

export const PromoCodeBanner = () => {
  const { data: promoCodes } = useQuery({
    queryKey: ["promo-codes-auto"],
    queryFn: getPromoCodes,
  });

  const activePublicPromos = promoCodes?.filter((promo) => {
    const now = new Date();
    const startDate = new Date(promo.start_date);
    const expirationDate = promo.expiration_date ? new Date(promo.expiration_date) : null;
    return (
      promo.public_promo &&
      startDate <= now &&
      (!expirationDate || expirationDate >= now) &&
      (!promo.max_uses || promo.times_used < promo.max_uses)
    );
  });

  if (!activePublicPromos || activePublicPromos.length === 0) return null;

  return (
    <div className="bg-villa-blue text-white py-2.5 px-4 text-center text-sm animate-fade-in relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-villa-turquoise/20 to-transparent pointer-events-none" />
      <div className="relative flex items-center justify-center gap-3 flex-wrap">
        <Sparkles className="h-3.5 w-3.5 text-villa-turquoise-light flex-shrink-0" />
        <span className="font-medium text-white/90">Promotions en cours :</span>
        <div className="flex gap-2 flex-wrap justify-center">
          {activePublicPromos.map((promo) => (
            <span
              key={promo.id}
              className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-villa-turquoise/25 text-villa-turquoise-light font-medium text-xs border border-villa-turquoise/30"
            >
              {promo.code} — {promo.discount_value}{promo.discount_type === "percentage" ? "%" : "€"} de réduction
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
